import React from 'react';
import { Link } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { isAllowed } from 'helpers';

export const getColumns = (intl, user, handleDeleteUser) => [
  {
    field: 'firstname',
    headerName: intl.formatMessage({
      id: 'app.metusers.grid.colFirstName',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'lastname',
    headerName: intl.formatMessage({
      id: 'app.metusers.grid.colLastName',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'role_name',
    headerName: intl.formatMessage({
      id: 'app.metusers.gird.colRolName',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'tel',
    headerName: intl.formatMessage({
      id: 'app.metusers.grid.colTel',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'email',
    headerName: intl.formatMessage({
      id: 'app.metusers.grid.colEmail',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    renderCell: (params) => {
      const actions = [];
      if (isAllowed(user.permissions, ['metimur_user_delete'])) {
        actions.push(
          <Tooltip
            title={intl.formatMessage({
              id: 'app.metusers.grid.colAction.delete',
            })}
          >
            <IconButton
              onClick={() => handleDeleteUser(params.row)}
              color="error"
              aria-label={intl.formatMessage({
                id: 'app.metusers.grid.colAction.delete',
              })}
            >
              <Delete />
            </IconButton>
          </Tooltip>
        );
      }

      if (isAllowed(user.permissions, ['metimur_user_update'])) {
        actions.push(
          <Link
            to={`/updateAdminUser/${params.row.id}`}
            state={{ user: params.row, corpId: false }}
            style={{ textDecoration: 'none' }}
          >
            <Tooltip
              title={intl.formatMessage({
                id: 'app.metusers.grid.colAction.edit',
              })}
            >
              <IconButton
                aria-label={intl.formatMessage({
                  id: 'app.metusers.grid.colAction.edit',
                })}
                color="secondary"
              >
                <Edit />
              </IconButton>
            </Tooltip>
          </Link>
        );
      }
      return actions;
    },
    flex: 1,
    align: 'center',
    headerAlign: 'center',
  },
];
